<template>
  <div class="otp-field d-flex justify-center" :class="{'focus': hasFocus, 'dark' : dark}" v-bind="$attrs">
<!--    To turn off autocomplete when otp-input is password-->
    <input v-if="type === 'password'"
           autocomplete="off"
           name="hidden"
           type="text"
           style="display:none;"
           class="otp-field"
           >
    <SingleOtpInput
      v-for="(item, i) in length"
      :key="i"
      :focus="activeInput === i"
      :value="otp[i]"
      :separator="separator"
      :input-type="type"
      :input-classes="inputClasses"
      :is-last-child="i === length - 1"
      :autofocus="autofocus"
      @on-change="handleOnChange"
      @on-keydown="handleOnKeyDown"
      @on-paste="handleOnPaste"
      @on-focus="handleOnFocus(i)"
      @on-blur="handleOnBlur"
    />
  </div>
</template>

<script>
import SingleOtpInput from './SingleOtpInput.vue';
// keyCode constants
const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
export default {
  name: 'OtpInput',
  components: {
    SingleOtpInput,
  },
  props: {
    value: {
      default: null,
    },
    length: {
      default: 4,
    },
    separator: {
      type: String,
      default: null,
    },
    inputClasses: {
      type: String,
      default: function () {
        return 'otp-input'
      },
    },
    type: {
      type: String,
      validator(value) {
        return ['number', 'tel', 'password','text'].includes(value);
      },
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeInput: 0,
      otp: [],
      oldOtp: []
    };
  },
  computed: {
    hasFocus(){
      return this.activeInput > -1
    }
  },
  watch:{
    value(value){
      if (!value) return this.clearInput()
    }
  },
  methods: {
    handleOnFocus(index) {
      this.activeInput = index;
    },
    handleOnBlur() {
      this.activeInput = -1;
    },
    // Helper to return OTP from input
    checkFilledAllInputs() {
      if (this.otp.join('').length === this.length) {
        this.$emit('input', this.otp.join(''));
        return this.$emit('finish', this.otp.join(''));
      }
      return 'Wait until the user enters the required number of characters';
    },
    // Focus on input by index
    focusInput(input) {
      this.activeInput = Math.max(Math.min(this.length - 1, input), 0);
    },
    // Focus on next input
    focusNextInput() {
      this.focusInput(this.activeInput + 1);
    },
    // Focus on previous input
    focusPrevInput() {
      this.focusInput(this.activeInput - 1);
    },
    // Change OTP value at focused input
    changeCodeAtFocus(value) {
      this.oldOtp = Object.assign([], this.otp);
      this.$set(this.otp, this.activeInput, value);
      if (this.oldOtp.join('') !== this.otp.join('')) {
        this.$emit('change', this.otp.join(''));
        this.$emit('input', this.otp.join(''));
        this.checkFilledAllInputs();
      }
    },
    // Handle pasted OTP
    handleOnPaste(event) {
      event.preventDefault();
      const pastedData = event.clipboardData
        .getData('text/plain')
        .slice(0, this.length - this.activeInput)
        .split('');
      if (this.type === 'number' && !pastedData.join('').match(/^\d+$/)) {
        return 'Invalid pasted data';
      }
      // Paste data from focused input onwards
      const currentCharsInOtp = this.otp.slice(0, this.activeInput);
      const combinedWithPastedData = currentCharsInOtp.concat(pastedData);
      this.$set(this, 'otp', combinedWithPastedData.slice(0, this.length));
      this.focusInput(combinedWithPastedData.slice(0, this.length).length);
      return this.checkFilledAllInputs();
    },
    handleOnChange(value) {
      this.changeCodeAtFocus(value);
      this.focusNextInput();
    },
    clearInput() {
      if (this.otp.length > 0) {
        this.$emit('change', '');
        this.$emit('input', '');
      }
      this.otp = [];
      this.activeInput = 0;
    },
    // Handle cases of backspace, delete, left arrow, right arrow
    handleOnKeyDown(event) {
      switch (event.keyCode) {
        case BACKSPACE:
          event.preventDefault();
          this.changeCodeAtFocus('');
          this.focusPrevInput();
          break;
        case DELETE:
          event.preventDefault();
          this.changeCodeAtFocus('');
          break;
        case LEFT_ARROW:
          event.preventDefault();
          this.focusPrevInput();
          break;
        case RIGHT_ARROW:
          event.preventDefault();
          this.focusNextInput();
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style>
  .otp-input {
    width: 100%;
    height: 42px;
    padding: 5px;
    margin: 0 4px;
    font-size: 20px;
    border-radius: 4px;
    text-transform: uppercase;
    border: 1px solid rgba(0, 0, 0, 0.3)!important;
    text-align: center;
  }
  .otp-field.dark .otp-input{
    border: 1px solid rgba(255, 255, 255, 0.3)!important;
    color: white;
  }
  .otp-field.dark.focus .otp-input {
      border: 1px solid rgba(255, 255, 255, 0.8)!important;
  }
  .otp-field.focus .otp-input{
    border: 1px solid rgba(0, 0, 0, 0.6)!important;
  }
  .otp-input.error { 
    border: 1px solid red !important;
    }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>